import { Component, OnInit, ViewEncapsulation, Input, ViewChildren, QueryList } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'involved-parties',
  templateUrl: './involved-parties.component.html',
  styleUrls: ['./involved-parties.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InvolvedParties implements OnInit {
  private sub1: Subscription = new Subscription();
  partyIndex = 0;
  @Input() parentForm: any;
  @Input() parentName: string;
  @Input() partyType: string = "witness"; // Types : witness, other
  @ViewChildren('name') driverNames: QueryList<any>;

  constructor(private fb: FormBuilder) {
  }

  ngOnInit() {
    //this.form = this.fb.array([this.addFormGroup()]);
  }

  // Changes to rows only happen after this lifecycle event so you need
  // to subscribe to the changes made in rows.
  // This subscription is to avoid memory leaks
  ngAfterViewInit() {
    this.sub1 = this.driverNames.changes.subscribe(resp => {
      if (this.driverNames.length > 0) {
        setTimeout(() => {
          this.driverNames.last.nativeElement.focus();
        }, 150);
      }
    });

    if(this.formArray.controls.length == 0) {
      console.log("Involved Empty");
      this.addItem();
      //this.driverNames.first.nativeElement.focus();
    }
  }

  // Memory leak avoidance - unsubscribe
  ngOnDestroy(){
    this.sub1.unsubscribe();
  }

  addFormGroup() {
    return this.fb.group({
        registration: '',
        number_in_vehicle: [1, [Validators.required]],
        driver_name: ['', [Validators.required]],
        phone_number: '',
        injured: false,
        injury_details: '',
        people_property_details: '',
        photos: [new Array]
    });

  }

  addItem() {
      this.formArray.push(this.addFormGroup());
      //const _index = this.formArray.length - 1;
      // // Focus 
      // setTimeout(() => {
      //   const _fg = this.formArray.controls[_index] as FormGroup;
      //   const _field = _fg.controls['driver_name'];
      //   _field.focus();

      // }, 200);
  }
  removeItem(index) {
      this.formArray.removeAt(index);
  }

  get formArray() {
      return <FormArray>this.parentForm.get(this.parentName);
  }

  uploadPhotos() {

  }

  photoUpload(event, index) {
    let files = event;
    let formPhotoControls = <FormArray>this.formArray.controls[this.partyIndex];
    formPhotoControls.controls['photos'].setValue([]);

    this.partyIndex = index;
    if (files) {
      files.forEach(file => {
          let reader = new FileReader();
          reader.onload = this.handleReaderLoaded.bind(this);
          reader.readAsDataURL(file);
      });
    }
  }

  handleReaderLoaded(readerEvt) {
      let dataURL = readerEvt.target.result;
      let formPhotoControls = <FormArray>this.formArray.controls[this.partyIndex];
      let photoArray = formPhotoControls.controls['photos'].value;
      if(photoArray == null) {
        photoArray = [];
      }

      photoArray.push( {"notes":"","photo":dataURL} );
      formPhotoControls.controls['photos'].setValue(photoArray);
  }

}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/involved-parties/involved-parties.component.ts